// Third Party Library
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { message, Divider } from "antd";

// Constants

// Components
import { RemarkTextArea, RemarkLists } from "./components";
import { DrawerWrapper } from "../../../../../../components";

// Handlers

// Services Library
import { REDUX as REDUX_UTIL, TIME } from "../../../../../../services/util";
import * as REDUX_ACTION from "../../../../../../services/redux/actions";

import styles from './index.module.css'

const { reduxStoreWrapper } = REDUX_UTIL;

const DrawerComment = ({ isOpen, setIsOpen, data }) => {
  const dispatch = useDispatch();

  const user = useSelector(reduxStoreWrapper("user"));

  let remarks, loading;
  remarks = useSelector(reduxStoreWrapper("vamVehicleIssue.comments"));
  loading = useSelector(reduxStoreWrapper("style.loading.vam"));


  // markup settings initialization
  const [messageApi, contextHolder] = message.useMessage();
  const [showTextArea, setShowTextArea] = useState(true);
  const [showEditTextArea, setShowEditTextArea] = useState(true);

  // 'edit' feature initialization
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [record, setRecord] = useState(null);

  // value initialization
  const [value, setValue] = useState(null);
  
  // dataSource used in Remark List. Needs some adjustment
  let dataSource = Array.isArray(remarks)
    ? [...remarks].sort((a, b) => b.createdAt - a.createdAt)
    : [];

  const submitRemarkHDLR = (items, cb) => {
      dispatch(REDUX_ACTION.v3_vamVehicleIssues.cud_comment_vam_vehicle_issue_request({...items, action: 'C'}, cb()));
  };
  
  const updateRemarkHDLR = (data, cb) => {
      dispatch(REDUX_ACTION.v3_vamVehicleIssues.cud_comment_vam_vehicle_issue_request({...data, action: 'U'}, cb()));
  };
    
  const deleteRemarkHDLR = (items, cb) => {
      dispatch(REDUX_ACTION.v3_vamVehicleIssues.cud_comment_vam_vehicle_issue_request({...items, action: 'D'}, cb));
  };

  const handleOkButton = () => {
    messageApi.open({
      type: "loading", 
      content: "Updating remark...",
      duration: 0,
    });

    const createItem = (value) => {
      return {
        uid: user.uid,
        comment: {
          comment: value.comment,
          photos: value.url,
          vamiid: data.vamiid
        }
      };
    };
    

    const updatedItem = (value) => ({
      uid: user.uid,
      comment: {
        comment: value.comment,
        photos: value.url || record.photos,
        vamiid: data.vamiid,
        vamicid: record.vamicid
      }
    });

    try{
      switch (edit) { 
        // submit
        case false: {
          submitRemarkHDLR(createItem(value), () => messageApi.destroy);
          setShowTextArea(false);
          setValue(null);
          break;
        }
        // edit
        case true: {
          updateRemarkHDLR(updatedItem(value), () => messageApi.destroy);
          setShowTextArea(true);
          setShowEditTextArea(false)
          setEdit(false);
          setValue(null)
          setRecord(null);
          break;
        }
  
        default:
          break;
      }
    }
    finally {
      setEdit(false)
      setValue({...value, comment: '', url:''})
      setShowTextArea(true)
    }
  }

  // Simplify the reusable component
  const remarkListAttr = {
    dataSource,
    user,
    setIndex,
    setEdit,
    setValue,
    setShowEditTextArea,
    setShowTextArea,
    setRecord,
    showEditTextArea,
    value,
    edit,
    index,
    messageApi,
    handleOkButton,
    deleteRemarkHDLR,
    remarks,
    TIME,
    loading,
  };
  
  const RemarkTextAreaAttr = {
    value,
    setValue,
    handleOkButton,
    user,
  };

  const drawerClose = () => {
    setIsOpen(false);
    dispatch(REDUX_ACTION.v3_vamVehicleIssues.close_comment_success());
    setShowEditTextArea(false);
    setEdit(false);
  };

  // Main render
  return (
    <DrawerWrapper
      title={'Issue Comments'}
      placement="right"
      closable={false}
      width={510}
      onClose={drawerClose}
      open={isOpen}
    >
      {contextHolder}

      <div style={{padding: "24px"}}>
        <div>
          <h4>Vehicle Plate</h4>
          <p>{data?.plate}</p>
          <h4>Issues Description</h4>
          <p>{data?.desc}</p>
          <h4>Reported At</h4>
          <p>{TIME.parseDate(data?.reportedAt)}</p>
        </div>

        {showTextArea && (
          <RemarkTextArea {...RemarkTextAreaAttr} />
        )}

        <Divider className={styles['divider-layout']}/>

        <RemarkLists {...remarkListAttr} />
      </div>
    </DrawerWrapper>
  );
};

export default DrawerComment;
